export const PERMISSIONS = {
  CREATE_ADMIN: "createsubadmin",
  ANNOUNCEMENT: "announcement",
  LIBRARY: "library",
  PROGRAM: "program",
  TEAM: "team",
  BUSINESS: "business",
  USER: "user",
  FEEDBACK: "feedback",
  DONATION: "donation",
  DONATION_TYPE: "donation_type",
  GENERAL_SETTING: "general_setting",
  CALENDER_SETTING: "calender_setting",
  BANNER: "banner",
  DASHBOARD: "dashboard",
  MEMBERSHIP: "membership",
  // DAYS_ADJUSTMENT: "day's_adjustment"
};

